"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledGridColumn = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  flex-direction: column;\n  padding: 0px 20px;\n  display: block;\n  flex-grow: 0;\n  box-sizing: border-box;\n\n  &.pui-grid__column--size-1 {\n    width: 8.33%;\n  }\n\n  &.pui-grid__column--size-2 {\n    width: 16.66%;\n  }\n\n  &.pui-grid__column--size-3 {\n    width: 25%;\n  }\n\n  &.pui-grid__column--size-4 {\n    width: 33.33%;\n  }\n\n  &.pui-grid__column--size-5 {\n    width: 41.66%;\n  }\n\n  &.pui-grid__column--size-6 {\n    width: 50%;\n  }\n\n  &.pui-grid__column--size-12 {\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledGridColumn = _styledComponents["default"].div(_templateObject());

exports.StyledGridColumn = StyledGridColumn;

var GridColumn = function GridColumn(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return /*#__PURE__*/_react["default"].createElement(StyledGridColumn, props, children);
};

var _default = GridColumn;
exports["default"] = _default;